import { styled } from '@mui/system';
import { TableCell } from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';

import { AgColor } from '../../../stories/Styles/AgColor';

export const Main = styled('main')`
  position: relative;
  padding: 16px 32px;
  display: grid;
  gap: 16px;
`;

export const contentStyle = {
  backgroundColor: AgColor.grey0,
  maxWidth: '880px !important',
  marginTop: 0,
  padding: '16px 24px 24px 24px',
  border: `1px solid ${AgColor.grey3}`,
  borderRadius: '8px',
  boxShadow: '0px 1px 2px 0px #0000000D',
};

export const StyledTableCell = styled(TableCell)(
  ({ isAction }: { isAction?: boolean }) => ({
    [`&.${tableCellClasses.head}`]: {
      padding: '8px 10px',
      backgroundColor: 'white',
      boxShadow: 'none',
      borderRight: `1px solid ${AgColor.grey4}`,
      fontSize: 10,
      fontWeight: 700,
      color: AgColor.grey8,
      verticalAlign: 'middle',
    },
    [`&.${tableCellClasses.body}`]: {
      padding: isAction ? 0 : '18px 10px',
      borderRight: `1px solid ${AgColor.grey4}`,
      fontSize: 12,
      color: AgColor.grey9,
      textAlign: 'center',
      verticalAlign: 'middle',
      fontFamily: 'Inter, Sans-Serif',
    },
  })
);

export const TableContainer = styled('section')`
  overflow-y: auto;
  max-height: calc(100vh - 730px);
  border: 1px solid ${AgColor.grey4};

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e4e2e4;
    border-radius: 6px;
  }
`;

export const AdviceCard = styled('div')`
  margin: 16px 0 0 16px;
  padding: 8px 16px;
  border: 1px solid ${AgColor.errorHighlight};
  border-radius: 8px;
  background-color: ${AgColor.errorLight};
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const Notification = styled('div')`
  padding: 8px 16px;
  border-radius: 8px;

  &.customError {
    margin: 16px 0 0 16px;
    display: flex;
    gap: 16px;
    width: 100%;
    border: 1px solid ${AgColor.errorHighlight};
    background-color: ${AgColor.errorLight};
  }

  &.error {
    border: 1px solid ${AgColor.errorHighlight};
    background-color: ${AgColor.errorLight};
  }

  &.info {
    border: 1px solid ${AgColor.blueMain};
    background-color: ${AgColor.blueLight};
  }

  &.success {
    border: 1px solid ${AgColor.greenMain};
    background-color: ${AgColor.greenLight};
  }
`;
